export enum ComesGoesRounding {
  KEINE_RUNDUNG = 'KEINE_RUNDUNG',
  NACH_OBEN = 'NACH_OBEN',
  NACH_UNTEN = 'NACH_UNTEN',
  AUF_ODER_ABRUNDEN = 'AUF_ODER_ABRUNDEN',
}
